import { useEffect, useRef, useState } from "react";
import { partners } from "@/mocks/partners";

export default function PartnersHero() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  const totalProjects = partners.reduce((sum, p) => sum + p.projects, 0);
  const avgYears = Math.round(
    partners.reduce((sum, p) => sum + (new Date().getFullYear() - parseInt(p.since)), 0) / partners.length
  );

  return (
    <section ref={ref} className="relative min-h-[70vh] flex items-end overflow-hidden bg-[#1E3A8A]">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1400&q=80"
          alt="Stratejik Ortaklarımız"
          className="w-full h-full object-cover object-center opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/90 via-[#1E3A8A]/55 to-[#1E3A8A]/25"></div>
      </div>

      {/* Grid lines accent */}
      <div className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: "linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)",
          backgroundSize: "80px 80px"
        }}
      ></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 lg:px-10 pb-16 pt-40">
        <div className={`transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-16 bg-[#3B82F6]"></div>
            <span className="text-[#B8C5D8] text-xs font-semibold tracking-[0.35em] uppercase">Güçlü Ekosistem</span>
          </div>

          <h1
            className="text-white font-black uppercase leading-none mb-6"
            style={{ fontSize: "clamp(36px, 6vw, 80px)", letterSpacing: "-0.03em" }}
          >
            Stratejik<br />
            <span className="text-[#7B8FAF]">Ortaklarımız</span>
          </h1>

          <p className="text-[#DBEAFE] text-base md:text-lg leading-relaxed max-w-2xl mb-12">
            Dünyanın önde gelen teknoloji üreticileriyle kurduğumuz iş ortaklıkları,
            C2TEK'in sunduğu çözümlerin kalitesini, orijinalliğini ve sürekliliğini garanti altına alır.
          </p>

          {/* Stats Strip */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
            {[
              { val: partners.length.toString(), label: "Stratejik Ortak Firma" },
              { val: `${totalProjects}+`, label: "Ortak Proje Tamamlandı" },
              { val: `${avgYears} Yıl`, label: "Ortalama Ortaklık Süresi" },
              { val: "6 Sektör", label: "Temsil Edilen Uzmanlık Alanı" },
            ].map((s, i) => (
              <div key={i} className="bg-white px-6 py-5">
                <p
                  className="text-[#0F172A] font-black leading-none mb-1"
                  style={{ fontSize: "clamp(22px, 3vw, 36px)" }}
                >
                  {s.val}
                </p>
                <p className="text-[#64748B] text-xs tracking-wide">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
